import { Fragment } from "react"
import { Route, Routes } from "react-router-dom";
import Login from "../pages/Login";
import LayoutRoutes from "./LayoutRoutes";

const Routers = () => {
    return (
        <Fragment>
            <Routes>
                <Route exact path={`/`} element={<Login />} />
                <Route
                    exact
                    path={`/auth/login`}
                    element={<Login />}
                />
                <Route path={`/*`} element={<LayoutRoutes />} />
            </Routes>
        </Fragment>
    )
}
export default Routers